import React from 'react';
import ReactDOM from 'react-dom';
import LoginForm from './Form';

const LoginWebPart = element => {
    if (!element) {
        return;
    }

    const loginFormContainer = document.querySelector('.js-login-form');
    if (!loginFormContainer) {
        return;
    }

    const successUrl = loginFormContainer.dataset.successUrl;
    const expires = loginFormContainer.dataset.successCache;

    ReactDOM.render(
        <LoginForm
            successUrl={successUrl}
            expires={expires}
        />,
        loginFormContainer
    );
};

export default LoginWebPart;




// WEBPACK FOOTER //
// ./src/nams2020/webparts/Login/index.js